export default {
  common: {
    Unsaved_changes: 'Несохранённые изменения',
    There_are_unsaved_changes_in_this_comment: 'В этом комментарии есть несохранённые изменения.',
    Continue_editing: 'Продолжить редактирование',
    Drop_changes: 'Отбросить изменения',
    Add_link: 'Добавить ссылку',
    Enter_a_URL: 'Введите URL',
    Link_text: 'Текст',
    Enter_link_text: 'Введите отображаемый текст',
    Cancel: 'Отмена',
    Add: 'Добавить',
    Executed_by_agent: 'Выполнено {agent}',
    Save: 'Сохранить',
    Edit: 'Редактировать',
    Update: 'Обновить',
    Previous: 'Назад',
    Next: 'Далее',
    Loading: 'Загрузка…',
    Total: 'Итого',
    Details: 'Детали',
  },
  dayoff: {
    select_title: 'Выберите свои выходные',
    selection_hint: 'Клик по дню · тяните, чтобы выбрать диапазон',
    today: 'Сегодня',
    days_selected: 'дн. выбрано',
    selected_days: 'Выбранные дни',
    legend_selected: 'Выбрано',
    legend_your: 'Ваш выходной',
    legend_holiday: 'Праздничный день',
    legend_mate: 'Коллега отсутствует',
    away_this_period: 'Отсутствуют в этот период',
    nobody_away: 'В этот период никто не отсутствует',
    description: 'Описание',
    description_placeholder: 'напр. Отпуск, занятой день…',
    submit: 'Сохранить выходные',
    saved: 'Выходные сохранены: {range} — {count} дн.',
    saved_empty: 'Все выходные удалены',
    you: 'вы',
    tip_holiday: 'Праздник',
    tip_away: 'Отсутствуют',
    tip_out_count: 'Вне офиса: {count} чел.',
    tip_more: 'и ещё {count}',
    days_count: '{count} дн.',
    tip_holiday_war: 'Не выходной во время военного положения',
    on_dayoff_today: 'Сегодня выходной',
    gcal_title: 'Google Календарь',
    gcal_connect: 'Подключить Google Календарь',
    gcal_connected: 'Google Календарь синхронизирован',
    gcal_disconnect: 'Отключить',
    history_title: 'История запросов',
    history_period: 'Период',
    history_days: 'Дни',
    history_note: 'Заметка',
    history_added: 'Добавлено',
    history_empty: 'Вы ещё не брали выходных',
    history_requests: 'Запросов: {count}',
    history_used_year: 'Использовано в этом году: {count} дн.',
    days_short: '{count}д',
    unsaved_title: 'Несохранённые выходные',
    unsaved_message: 'Выбранные дни и заметка ещё не сохранены.',
    unsaved_keep: 'Продолжить редактирование',
    unsaved_drop: 'Отменить изменения',
    clear: 'Очистить',
  },
  board: {
    add_new_task: 'Создать задачу',
    add_stage: 'Добавить стадию',
    add_column: 'Добавить колонку',
    enter_stage_name: 'Введите имя стадии',
    no_stages_title: 'Стадий пока нет',
    no_stages_text: 'Добавьте первую стадию, чтобы начать создавать задачи.',
    need_stage_to_create_task: 'Сначала добавьте хотя бы одну стадию в проект, чтобы создать задачу.',
    Enter_task_description: 'Введите описание задачи',
    Delete_stage: 'Удалить стадию',
    sure_delete_stage: 'Вы уверены, что хотите удалить эту стадию?',
    really_delete_stage: 'Вы действительно хотите удалить стадию?',
    stage_also_leted: 'Все задачи в стадии также будут удалены!',
    CANCEL: 'Отменить',
    YES: 'Да',
    we_send_invite: 'Мы отправили приглашения на почту:',
    please_ask_user: 'Пожалуйста, попросите пользователя принять ссылку для присоединения к вашему проекту',
    okay: 'Хорошо',
  },
  comments: {
    bot_line1: 'Отлично! Так ты можешь открывать задачи.',
    bot_line2:
      'Как ты можешь видеть твое время работы над задачей уже учитывается и отображено в правом нижнем углу.',
    bot_line3: 'Тут ты можешь оставлять сообщения связанные с задачей или перетаскивать сюда файлы',
    max_pins_reached: 'Разрешено максимум 5 закрепленных комментариев',
    pin_comment: 'Закрепить комментарий',
    pinned_comments: 'Закрепленные комментарии',
    add_reaction: 'Добавить реакцию',
  },
  notifications: {
    title: 'Уведомления',
    mark_all_read: 'Отметить все прочитанными',
    read_all: 'Прочитать все',
    all_caught_up: 'Новых уведомлений нет',
    all_caught_up_hint: 'Здесь появятся упоминания, приглашения и запросы',
    added_you_to_project: 'добавил(а) вас в проект',
    open_project: 'Открыть проект',
    rejected_invite_workspace: 'отклонено приглашение в эту рабочую зону',
    requested_to_add: 'запрос на добавление',
    for: 'для',
    Task: 'Задача',
    task_created: 'создана',
    task_deleted: 'удалена',
    task_transferred: 'перенесена',
    task_restored: 'восстановлена',
    Restore: 'Восстановить',
    image_deleted: 'Изображение удалено',
    NEW: 'НОВЫЙ',
    Accept: 'Подтвердить',
    Reject: 'Отклонить',
    Accepted: 'Подтверждено',
    Rejected: 'Отклонено',
    Viewed: 'Просмотрено',
    Then_Deleted: 'Затем удалено',
    Then_Canceled: 'Затем отменено',
    by: 'пользователем',
    notify_assigned: 'назнач. Вас на',
    mention_in_task: 'упоминание в',
    mentioned_you_in_task: 'упомянул вас в задаче',
    to_a_task: 'на задачу',
    new_assign: 'Назначил(а) вас на задачу',
    offline_mode: 'Офлайн-режим',
    no_new_version_found: 'Новая версия не найдена',
    your_account_deleted: 'Ваш аккаунт был удален',
    dayoff_title: 'Выходной',
    dayoff_notice: 'в выходном {dates}',
    dayoff_takes: 'берёт выходной',
    dayoff_is_off: '{name} берёт выходной',
    user_commented: '{name} комментирует',
    user_assigned_you: '{name} назначает вас',
    open_task: 'Открыть задачу',
    open_calendar: 'Открыть календарь',
    invoice_autogen_failed: 'Не удалось автоматически сгенерировать инвойс за {month}, шаблон',
    invoice_autogen_sent: 'Инвойс за {month} отправлен автоматически, шаблон',
    open_invoice_generator: 'Открыть генератор инвойсов',
    dismiss: 'Скрыть',
  },
  uploads: {
    not_uploaded: '{count} не загружено',
    queued: 'В очереди',
    saving: 'Сохраняю',
    done: 'Готово',
    retry_attempt: 'Повтор {attempt} из {max}',
    offline: 'Жду сеть',
    failed: 'Не загружено',
    retry: 'Повторить',
    remove: 'Убрать',
    errors: {
      too_large: 'Больше {limit}, не загружено',
      not_uploaded: 'Файл не дошёл до хранилища',
      storage_refused: 'Хранилище отклонило файл',
      unreachable_storage: 'Не удалось связаться с хранилищем',
      server_error: 'Сервер не смог сохранить файл',
    },
  },
  system: {
    syncing: 'Синхронизация с облаком',
    __resume_button: 'Продовжити',
    __ok_button: 'OK',
    __stop_button: 'Стоп',
    __hide_button: 'Приховати',
    __resume_last_task: 'Продовжити останню задачу',
    __create_task_notify: 'Створити задачу',
    __not_tracking_title: 'Вы не трекаете',
    __not_tracking_subtitle: 'уже 10 минут',
    __still_here_title: 'Вы ещё здесь?',
    __still_here_subtitle: 'Давно нет активности — трекинг остановится',
    __still_here_confirm: 'Я здесь',
    __wait_install_app: 'Будь ласка, зачекайте. Встановлення трекліфая...',
    __accept_button: 'Погодитись',
    __reject_button: 'Відмінити',
    __mute_tomorrow: 'Отключить на сегодня',
    __muted_title: 'Напоминания отключены',
    __muted_subtitle: 'до завтра',
    __undo: 'Отменить',
    __timer_running: 'Таймер работает',
    __approve_tracked_time: 'Подтвердите отслеженное время',
    __no_estimate: 'Без оценки',
    __not_tracking_label: 'Трекинг не идёт',
    __until_tomorrow: 'До завтра',
    __no_activity_detected: 'Активность не обнаружена',
    __open_app: 'Відкрити застосунок',
    __cancel: 'Відміна',
    __you_resume_tracking: 'Ви продовжуєте останню задачу:',
    /* Main notify */
    __tracker_was_closed: 'Застосунок було закрито з активною задачею',
    __tracking_resume: 'Трекинг возобновлён',
    __new_version_found: 'Знайдено нову версію',
    __new_version_found_but_error:
      'Знайдено нову версію, але на жаль ваша система не підтримує автоматичного оновлення',
    __new_version_download_button: 'Встановити',
    __later_button: 'Пізніше',
    __dismiss_button: 'Відклонити',
    __downloading_version: 'Встановлення нової версії',
    __install_button: 'Встановлення',
    __downloading_version_percent: 'Завантаження нової версії',
    __failed_download: 'Помилка завантаження нової версії',
    __try_again: 'Ще раз',
    __installing_new_version: 'Встановлення нової версії',
    __failed_install: 'Помилка встановлення нової версії',
    __failed_open_new_version:
      'Помилка відкриття нової версії. Будь ласка, закрийте застосунок  і відкрийте знову',
    __close_app: 'Закрити застосунок',
    __tracking_stopped: 'Трекінг зупинено: система простоює',
    __tricking_resume: 'Трекінг продовжено: активація системи',
    __tracking_stopped_shutdown: 'Трекінг зупинено: Комп’ютер вимикається',
    __tricking_resume_unlocked: 'Трекінг продовжено: екран разблоковано',
  },
  appRunner: {
    run_tracker: 'Мой трекер',
    not_installed: 'Не установлен',
    started: 'Запущен',
    starting: 'Запускается',
    install_app_to_track: 'Установите приложение на рабочий стол',
    instalattion_is_simple: 'Забудьте про диалог "Откройте доступ к экрану", получайте комфортные нотификации благодаря настольному приложению Tracklify!',
    install_desktop: 'Установите приложение Tracklify на рабочий стол для непрерывного трекинга',
    install_step1: 'Скачайте приложение',
    install_step2: 'Запустите скачанный файл',
    see_other_platforms: 'Посмотреть версии для других платформ',
    install_help: 'Видео помощь',
    done_button: 'Уже установлено, закрыть',
    already_installed: 'Уже установлено? Можно закрыть эту страницу.',
    download_app: 'Скачать приложение для Windows',
    download_app_deb: 'Скачать для Ubuntu, Mint, других Debian',
    download_app_rpm: 'Скачать для Redhat, Fedora, других RPM',
    download_app_pacman: 'Скачать для Arch Linux, других на базе Arch Linux',
    download_app_mac: 'Скачать для macOS (Файл DMG)',
  },
  search: {
    search_or_navigate: 'Поиск и фильтры',
    hint: 'Введите слово из задачи, имя участника,<br> тег или название проекта',
    nothing_found: 'Ничего не найдено ¯\\_(ツ)_/¯',
    go_to: 'Перейти к',
    open: 'Открыть',
    in: 'в',
    in_tasks: 'Искать в задачах:',
    invite: 'Пригласить',
    invite_to_project: 'в рабочую зону и проект',
    invite_user: 'Пригласить',
    tasks_on: 'задачи на:',
    tasks_by: 'задачи от:',
    unassigned: 'Не назначен',
    noTag: 'Без тегов',
    clear_all: 'Очистить всё',
    clear: 'Очистить',
    tagged: 'помечено',
    show_all_tags: 'Показать все теги',
    on: 'на',
    by: 'от',
    sign_up_not_confirmed: 'Регистрация в рабочей области не подтверждена',
  },
  menu: {
    Pause: 'Пауза',
    Resume: 'Старт',
    myTasks: 'Мои задачи',
    nav_menu: 'Меню',
    nav_tasks: 'Задачи',
    nav_alerts: 'Уведомления',
    nav_me: 'Я',
    task_history: 'История задач',
    view_all_task_history: 'Вся история задач',
    __open_logs: 'Открыть логи',
    __check_updates: 'Проверить обновления',
    __enable_window_titles: 'Включить заголовки окон',
    __devtools: 'DevTools',
    __quit: 'Выйти из приложения',
    download_app: 'Скачать приложение',
    summary_report: 'Общий отчет',
    dayoff: 'Day Off',
    time_reports: 'Подробные отчеты',
    projects: 'Проекты',
    create_project: 'Создать новый проект',
    salary: 'Зарплата',
    profit_share: 'Profit-share',
    project_settings: 'Настройки проекта',
    ai_assistant: 'ИИ-ассистент',
    profile: 'Профиль',
    dark_mode: 'Тем-я тема',
    my_screenshots: 'Мои скриншоты',
    logout: 'Выйти',
    get_help: 'Получить помощь',
    about: 'Про Треклифай',
    ai_automation: 'AI и автоматизация',
    workspace: 'Рабочая зона',
    switch_workspace: 'Сменить рабочую зону',
    workspace_settings: 'Опции рабочей зоны',
    create_new_workspace: 'Новая рабочая зона',
    workspace_name: "Название рабочей зоны",
    personal_workspace: "Личная рабочая зона",
    create_workspace: "Создать",
    create_workspace_failed: "Не удалось создать рабочую зону, попробуйте ещё раз",
    invite_to_project: 'Пригласить пользователя в проект',
    already_member_project: 'Пользователь уже является членом проекта',
    resend_invite_button: 'ОПРАВИТЬ ПОВТОРНО',
    no_users_found: 'Пользователь не найден, введите е-мейл для приглашения',
    invite_failed: 'Не удалось пригласить {email}: проверьте адрес',
    settings: '— опции',
    Project_name: 'Название проекта',
    task_short_id: 'Короткий иден-р задачи',
    Task_ID_example: 'Например',
    already_taken: 'Уже использовано в рабочей зоне',
    Please_change: 'Пожалуйста измените',
    Prefix: 'Префикс',
    Template: 'Правила',
    Project_background: 'Фон проекта',
    change: 'ИЗМЕНИТЬ',
    create: 'СОЗДАТЬ',
    Select_a_picture: 'Выберите фон проекта',
    Examples: 'Например:',
    pick_a_color: 'или выберите цвет',
    create_project_hint: 'Назовите его, выберите шаблон колонок и фон.',
    Search_pictures: 'Поиск картинок — абстракция, градиент, огни…',
    Create_project: 'Создать проект',
    Resend_invite: 'Повторно отправить приглашение в проект и рабочее пространство для',
    user_invite: 'Нажмите на пользователя, чтобы пригласить',
    get_app: 'Скачать прило-е',
    add_task: 'Добавить',
    mentions_notify_1: 'У вас есть',
    mentions_notify_2_single: 'задача с упоминанием',
    mentions_notify_2_multy: 'задачи с упоминанием',
    task_create: 'Создать задачу',
    notifications: 'Уведомления',
    no_new_notifications: 'Нету новых оповещений',
    new_notification: 'новое',
    new_notifications: 'новых',
  },
  reports: {
    executors: 'Исполнители',
    now_working: 'Прямо сейчас работают',
    no_active_tasks: 'Никто не работает',
    work_one_day: 'Работа за один день',
    today: 'Сегодня',
    work_this_month: 'Работа в этом месяце',
    member: 'Участник',
    activity: 'Активность',
    total: 'Всего',
    no_time_tracked: 'Пока нет затреканого времени',
    no_time_tracked_this_month: 'Пока нет затреканого времени в этом месяце',
    date_range: 'Период времени',
    select_date_range: 'Выберите период времени',
    show_filters: 'Показать фильтры',
    hide_filters: 'Скрыть фильтры',
    filter_projects: 'Включить проекты',
    select_projects: 'Выберите проекты',
    filter_labels: 'Только задачи с тегами',
    filter_exclude_labels: 'Исключить задачи с тегами',
    select_label: 'Выберите тег',
    filter_executors: 'Включить исполнителей',
    select_executors: 'Выбрать исполнителей',
    group_by: 'Группировать по',
    group_projects: 'Проектам',
    by_weeks: 'По неделям',
    by_month: 'По месяцам',
    dont_group: 'Не по чем',
    no_tasks: 'Не найдено задач по этому запросу',
    total_time: 'Общее время',
    total_time_by_day: 'Общее время по дням',
    burnup_chart: 'График роста часов',
    all_spent: 'Всего<br/>потрачено',
    time_by_task: 'Время, потраченное на задачи за период',
    invoice: 'Создать счет',
    roles: 'Ролям',
    search: 'Поиск',
    select_all: 'Выбрать все',
    unselect_all: 'Очистить выбор',
    now: 'сейчас',
    Enter_project_name: 'Введите имя проекта',
    screenshots: 'Скриншоты',
    empty: 'Пусто',
    screenshots_empty_title: 'Нет скриншотов',
    screenshots_empty_hint: 'За выбранные даты и фильтры ничего не снято.',
    time_empty_title: 'Нет отслеженного времени',
    time_empty_hint: 'За выбранные даты и фильтры ничего не отслежено.',
    last_month: 'Последний месяц',
    this_month: 'Этот месяц',
    this_year: 'Этот год',
    all_time: 'За всё время',
    Ok: 'Ок',
    YES: 'ДА',
    CANCEL: 'ОТМЕНА',
    Cancel: 'Отмена',
    Tasks: 'Задачи',
    Time: 'Время',
    Tasks_details: 'Детали задач',
    enter_variables_values: 'Введите значение переменных',
    are_you_sure_delete_template: 'Вы уверены, что хотите удалить шаблон?',
    are_you_sure_new_template: 'Вы уверены, что хотите сохранить этот шаблон?',
    Template: 'Шаблон',
    Select_template: 'Выберите шаблон',
    New_template_name: 'Новое название шаблона',
    DOWNLOAD_PDF: 'СКАЧАТЬ PDF',
    basic_example: 'Базовый пример',
    worker_salary: 'Зарплата работника',
    devforth_salary: 'Зарплата Devforth',
    executor: 'Исполнитель',
    created: 'Дата создания',
    contributors: 'Участники',
    value: 'Значение',
    progress: 'Прогресс',
    accuracy: 'Точность',
    spent_by: 'Потрачено',
    by_executor: 'исполнителем',
    total_spent_by: 'Всего потрачено',
    by_contributors: 'участниками',
    export: 'Экспорт',
    configure_columns: 'Настроить колонки',
    more_actions: 'Больше действий',
    round_hours_to: 'Округлить часы до',
    export_to_csv: 'Экспорт в CSV',
    export_to_gsheets: 'Экспорт в Google Sheets',
  },
  placeholders: {
    e_g: 'Например, Новый проект',
    Type_anything: 'поиск',
  },
  settings: {
    configure: 'Настройки проекта',
    delete_project: 'Удалить проект',
    Can_not_be_empty: 'Не может быть пустым',
    New_prefix: 'Префикс',
    Save: 'Сохранить',
    Cancel: 'Отменить',
    general: 'Общее',
    Labels: 'Тэги',
    Members: 'Участники',
    Tracker_Rules: 'Кнопки потока',
    Notifications: 'Уведомления',
    notification_settings_title: 'Уведомления проекта',
    notify_member_dayoff: 'Уведомлять меня, когда участник проекта берет выходной',
    Stages: 'Стадии',
    No_labels_yet: 'Тэгов пока нет',
    Admin: 'Администратор',
    Not_a_member: 'не участник',
    Member: 'Участник',
    Role_on_project: 'Роль в проекте',
    Actions: 'Действия',
    Permissions: 'Права',
    Other: 'Другая',
    Invite_member: 'Пригласить',
    exclude_the_user: 'Вы уверены, что хотите исключить пользователя из проекта?',
    Exclude: 'Исключить',
    Configure_workspace: 'Настройка рабочей зоны',
    Workspace_name: 'Имя рабочей зоны',
    Logo: 'Лого',
    save: 'Сохранить',
    Workspace_UI_language: 'Язык интерфейса рабочей зоны',
    Workspace_alias: 'Базовый URL зоны',
    General: 'Общее',
    Priorities: 'Приоритеты',
    Edit_tag_name: 'Изменить имя тега:',
    Pick_a_color: 'Выберите цвет',
    DELETE_TAG: 'УДАЛИТЬ ТЕГ',
    ARCHIVE_TAG: 'АРХИВИРОВАТЬ ТЕГ',
    UNARCHIVE_TAG: 'РАЗАРХИВИРОВАТЬ ТЕГ',
    TASKS: 'ЗАД.',
    EDIT: 'Изменить',
    confirm_delete: 'Вы уверены, что хотите удалить проект?',
    archive: 'Архивировать | архивировать | Архив',
    unarchive: 'Разархивировать | разархивировать',
    confirm_archive: 'Вы уверены, что хотите {action} проект?',
    cant_undone: 'Это не может быть отменено',
    confirm_user_deletion: 'Вы уверены что хотите удалить пользователя?',
    CANCEL: 'ОТМЕНИТЬ',
    YES: 'ДА',
    Yes: 'Да',
    delete: 'Удалить',
    only_admin_can_delete_user: 'Только администратор рабочей зоны может удалять его членов',
    only_admin_can_change_language: 'Только администратор рабочей зоны может изменить язык',
    ADMIN: 'АДМИНИСТРАТОР',
    MEMBER: 'УЧАСТНИК',
    GUEST: 'ГОСТЬ',
    FINANCE: 'ФИНАНСИСТ',
    admin_description: 'Имеет полный доступ',
    member_description: 'Имеет доступ только к проектам, в которые он приглашен, но может видеть отчеты о временем для всех членов и всех проектов. Может видеть названия задач чужих проектов.',
    guest_description: 'Имеет доступ только к проектам, в которые он приглашен, он видит отчеты о временем для всех участников доступных проектов.',
    doScreenshots: 'Делать скриншоты для подтверждения работы',
    single_admin_role_warning: 'Вы не можете изменять права доступа для единсвенного администратора',
    owner_role_warning: 'Вы не можете изменять права доступа владельца рабочей зоны',
  },
  workspaceSettings: {
    general_subtitle: 'Название воркспейса, логотип, язык и фирменный цвет',
    members_subtitle: 'Люди в воркспейсе и их роли',
    priorities_subtitle: 'Порядок проектов в «Моих задачах» каждого участника',
    name_saved: 'Название воркспейса сохранено',
    logo_saved: 'Логотип воркспейса сохранён',
    timezone_saved: 'Основной часовой пояс сохранён',
    brand_color: 'Фирменный цвет',
    main_timezone: 'Основной часовой пояс',
    search_timezone: 'Поиск часового пояса',
    language: 'Язык',
    role: 'Роль',
    admins: 'Администраторы',
    pending_invites: 'Ожидают принятия',
    name_hint: 'Показывается в переключателе воркспейсов и в приглашениях.',
    language_hint: 'Язык по умолчанию для всех в воркспейсе.',
    brand_color_hint: 'Используется в отчётах, экспортированных в Google Sheets.',
    timezone_hint: 'Отчёты о времени и счета считают дни в этом часовом поясе. Изменить его могут только владелец и администраторы.',
  },
  projectSettings: {
    group_project: 'Проект',
    group_people: 'Люди',
    group_automation: 'Автоматизация',
    integrations: 'Интеграции',
    general_subtitle: 'Название и внешний вид проекта',
    tags_subtitle: 'Метки для категоризации задач на этой доске',
    stages_subtitle: 'Колонки доски — измените порядок, чтобы изменить флоу',
    members_subtitle: 'Люди с доступом к проекту и их роли',
    flow_subtitle: 'Действия больших флоу-кнопок на странице задачи, для каждой стадии',
    integrations_subtitle: 'Подключённые сервисы, отправляющие данные в Tracklify',
    tasks_total: 'Всего задач',
    name_hint: 'Отображается в сайдбаре, хедере доски и в каждой ссылке на задачу.',
    background: 'Фон доски',
    background_hint: 'Изображение за колонками доски. Приглушено, чтобы карточки оставались читаемыми.',
    no_background: 'Без фона',
    photo_by: 'Фото:',
    screenshots_hint: 'Скриншоты во время работы таймера, привязанные к отслеженному времени.',
    enabled: 'Включено',
    disabled: 'Выключено',
    change: 'Изменить',
    archive_title: 'Архивировать проект',
    archive_hint: 'Скрывает его из сайдбара и переключателя досок. Отслеженное время остаётся в отчётах — восстановить можно в любой момент.',
    archive_button: 'Архивировать',
    unarchive_title: 'Восстановить проект',
    unarchive_hint: 'Возвращает его в сайдбар и переключатель досок.',
    unarchive_button: 'Разархивировать',
    delete_title: 'Удалить проект',
    delete_hint: 'Удаляет проект вместе с задачами.',
    tag: 'Тег',
    used_on: 'Используется',
    tasks_count: '{count} задач',
    edit: 'Изменить',
    archived: 'В архиве',
    archive: 'Архивировать',
    unarchive: 'Разархивировать',
    add_tag: 'Добавить тег',
    new_tag: 'Новый тег',
    tag_name: 'Название тега',
    create: 'Создать',
    stage: 'Стадия',
    tasks: 'Задачи',
    order: 'Порядок',
    add_stage: 'Добавить стадию',
    stage_name: 'Название стадии',
    rename_stage: 'Переименовать стадию',
    stage_name_hint: 'Отображается как заголовок колонки на доске.',
    to_save: 'чтобы сохранить',
  },
  projectRules: {
    when_task_in_stage: 'Когда здача на стадии',
    secondary_button: 'Второстепенная кнопка (слева)',
    primary_button: 'Главная кнопка',
    this_rule_willnot_work: 'Это правило не будет работать',
    add_action: 'Добавить действие',
    similar_item_was_used: 'аналогичный элемент уже использовался',
    preview: 'Предварительный вид',
    move: 'Отправить',
    move_to: 'Отправить в',
    assign: 'Назначить',
    assign_if_not_assigned: 'Назначить если не назначено',
    assign_mention: 'Назначить упомянутого',
    unassign: 'Отменить назначение',
    auto_click_after: 'Автоклик после',
    activate_button_if_user_mentioned_in_comment: 'Активировать кнопку, если пользователь упомянут (@) в комментарии',
    auto_click_after_tracked_1: 'Автоклик после',
    auto_click_after_tracked_2: 'трекинга',
    minutes: 'м',
    Me: 'Себя',
    Task_creator: 'Создателя задачи',
    no_buttons: 'Кнопки не показываются',
  },
  task: {
    edited: 'изменено',
    Actions: 'Действия',
    noDescription: 'Пока без описания',
    timeSpent: 'Потрачено времени',
    ago: 'назад',
    by: '',
    ADD_A_CHECKLIST: 'Добавить пункты',
    ADD_A_CHECKLIST_ITEM: 'Добавить пункт',
    Created_task_in: 'Создана задача в ',
    Assigned: 'Назначен(а) исполнитель',
    Changed_task_description: 'Изменено описание задачи',
    Transferred_task_from: 'Перенесено задачу из',
    Type_comment: 'Комментарий',
    SET_EST: 'Оц. зад.',
    SET_ESTIMATE: 'Оценить задачу',
    Clear: 'Очистить',
    STORY_POINTS: 'Стори поинты',
    Estimate: 'Оценка',
    Progress: 'Прогресс',
    Add_time: 'Добавить время',
    est: 'оц.',
    Code_block: 'Блок кода',
    List: 'Список',
    Video: 'Видео',
    USUAL: 'ОБЫЧНО',
    PRIO: 'Важность',
    Set_estimate_to: 'Оценил(а) задачу',
    Set_priority: 'Установил(а) приоритет',
    Delete_task: 'Удалить задачу',
    Screenshots: 'Скриншоты',
  Add_manual_time: 'Добавить время',
  Add_to_liked: 'Добавить в понравившиеся',
    CANCEL: 'Отменить',
    YES: 'Да',
    Back_to_task: 'Вернуться к задаче',
    What_were_you_doing: 'Над чем вы работали?',
    manual_how_long: 'Сколько времени?',
    manual_set_exactly: 'или укажите точно',
    manual_description_placeholder: 'напр. Звонок с клиентом о планах на Q4',
    manual_request: 'Запросить {duration}',
    manual_pick_hint: 'Проведите по шкале, чтобы выбрать, когда вы работали',
    manual_tab_range: 'Интервал',
    manual_tab_duration: 'Длительность',
    manual_today: 'Сегодня',
    manual_earlier: 'Раньше',
    manual_later: 'Позже',
    manual_legend_tracked: 'Отслежено',
    manual_legend_request: 'Этот запрос',
    manual_time_admin_required: 'Ручное время проверяет админ воркспейса, а в этом проекте его нет. Добавьте админа в проект:',
    manual_time_request_refused: 'Ручное время не запрошено. Обновите страницу и попробуйте снова.',
    manual_time_update_refused: 'Ручное время не обновлено: его уже обработали или у вас больше нет доступа. Обновите страницу, чтобы увидеть текущее состояние.',
    Type_item: 'Опишите пункт',
    to_normal: 'обычный',
    ASSIGN: 'Назначен',
    SEARCH_ASSIGNEE: 'Поиск исполнителя',
    add: 'добавить',
    change: 'изменить',
    nowin: 'Сейчас',
    Tags: 'Теги',
    Unassign: 'Не назначен',
    just_now: 'только что',
    Removed_assignee: 'Удалил(a) исполнителя',
    Moved_to: 'Передвинул(a) в',
    Added_tag: 'Добавил(a) тег',
    Removed_tag: 'Удалил(a) тег',
    Added: 'Добавил(a)',
    Reqested_to_add: 'Запрос на добавление',
    Approved: 'Подтвердил(а)',
    Rejected: 'Отказал(а)',
    Canceled: 'Отменил(а)',
    Deleted: 'Удалил(а)',
    by_trigger: 'по триггеру',
    REMOVE: 'Удалить',
    Are_you_sure: 'Вы уверены?',
    Are_you_sure_you_want_to_delete_this_image: 'Вы уверены, что хотите удалить это изображение?',
    set_as_task_preview: 'Сделать превью задачи',
    max_images_reached: 'Можно загрузить не более {limit} изображений за раз',
    current_task_preview: 'Текущее превью задачи',
    next_image: 'Следующее изображение',
    previous_image: 'Предыдущее изображение',
    Are_you_sure_you_want_to_delete_this_comment: 'Вы уверены, что хотите удалить этот комментарий?',
    Are_you_sure_you_want_to_delete_this_checklist_item: 'Вы уверены, что хотите удалить этот пункт чек-листа?',
    Delete: 'Удалить',
    Yes: 'Да',
    No: 'Нет',
    manual_CANCEL: 'Отменить',
    manual_Remove: 'Удалить',
    manual_YES: 'Да',
    delete_screenshot_title: 'Удалить этот скриншот?',
    delete_screenshot_subtitle: 'Это действие нельзя отменить',
    Add_tags: 'Добавить тэг',
    create_new_tag: 'Создать новый тэг',
    search_or_create_tag: 'Найти или создать тег...',
    No_screenshots_here_enable: 'Пока здесь нет скриншотов, продолжайте трекать время и они появяться',
    No_screenshots_here_disable: 'Скриншоты для этого проекта отключены',
    No_screenshots_here_disable_admin_part1: 'Скриншоты для этого проекта отключены. Откройте ',
    No_screenshots_here_disable_admin_part2: 'настройки',
    No_screenshots_here_disable_admin_part3: ', чтобы изменить их',
    SPENT: 'ПОТРАЧЕНО',
    oops: 'Упс!',
    cannot_find_page: 'Мы не можем найти страницу, которую вы ищете',
    start_from_home: 'На главную страницу',
    nf_title: 'Здесь ничего нет.',
    nf_subtitle: 'Запрошенной страницы не существует. Проверьте URL или вернитесь на знакомую страницу.',
    go_to_homepage: 'На главную страницу',
    go_back: 'Назад',
    spent_time: 'Затраченое время',
    copy_to_clipboard: 'Скопировать в буфер обмена',
    copied_to_clipboard: 'Ссылка скопирована в буфер обмена',
    copy_video_link: 'Копировать ссылку',
    volume: 'Громкость',
    converting_video: 'Конвертируется…',
    picture_in_picture: 'Картинка в картинке',
    expand_video: 'Увеличить',
    collapse_video: 'Уменьшить',
    we_are_still_processing_video: 'Мы все еще обрабатываем видео',
    video_available_not_for_all_platforms: 'Видео пока недоступно для платформ, не поддерживающих WebM. Мы проводим дополнительную конвертацию в MP4. Пожалуйста, подождите.',
    move_to: 'Отправить в',
    unassign: 'Открепить',
    assign: 'Назначить',
    unable_to_restore_image: 'Невозможно восстановить изображение.',
    Record_screen: 'Запись экрана',
    screenshot_activity: 'Активность',
    my_last_screenshots: 'Мои последние скриншоты',
    view_all: 'Посмотреть все',
    Executor: 'Исполнитель',
    edit: 'изменить',
    Stage: 'Стадия',
    NoStage: 'Без стадии',
    PriorityLow: 'Низкий',
    PriorityUsual: 'Обычный',
    PriorityHigh: 'Высокий',
    PriorityUrgent: 'Срочный',
    PrioritySuperUrgent: 'Очень срочный',
    Unset: 'Не задано',
    Change_project: 'Перенести задачу',
    Please_select_project_to_move: 'Выберите проект для переноса',
    No_transfer_available: 'Перенос недоступен',
    Created_by: 'Создан(а)',
    transfer_unavailable: {
      not_creator: 'Перенос может сделать только создатель, а вы не создатель',
      single_project: 'В рабочей области только один проект — переносить некуда',
      child_task: 'Невозможно перенести отдельную подзадачу',
    },
    are_you_sure_transfer_task: 'Вы уверены, что хотите перенести задачу?',
    time_save_but_screenshots_unavailable: 'Скриншоты и отслеженное время будут сохранены, но недоступны для просмотра в перенесенной задаче.',
    screenshots_from_tracked_time: 'Скриншоты из отслеживаемого времени',
  },
  theme: {
    title: 'Тема',
    dark: 'Тёмная',
    light: 'Светлая',
    pink: 'Розовая',
    violet: 'Фиолетовая',
    lime: 'Салатовая',
  },
  themeEditor: {
    new_theme: 'Новая тема',
    new_title: 'Новая тема',
    edit_title: 'Редактировать тему',
    unsaved_message: 'Изменения в теме ещё не сохранены.',
    name: 'Название',
    name_placeholder: 'Моя тема',
    mode: 'Режим',
    colors: 'Цвета',
    seed_base: 'Фон',
    seed_ink: 'Текст',
    seed_accent: 'Акцент',
    fine_tune: 'Тонкая настройка',
    overrides_hint: 'Необязательно. Пустые цвета следуют цветам выше.',
    token_bg2: 'Панели',
    token_control: 'Кнопки',
    token_card: 'Карточки',
    token_chrome: 'Верхняя панель',
    token_line: 'Границы',
    'token_text-muted': 'Второстепенный текст',
    'token_accent-soft': 'Оттенок акцента',
    token_red: 'Красный',
    token_green: 'Зелёный',
    token_blue: 'Синий',
    reset: 'Сбросить',
    share: 'Поделиться с пространством',
    share_hint: 'Участники {workspace} тоже смогут её выбрать',
    shared: 'Доступна пространству',
    shared_by: 'Поделился {name}',
    delete: 'Удалить',
    delete_title: 'Удалить тему?',
    cancel: 'Отмена',
    save: 'Сохранить',
    preview: 'Предпросмотр',
    preview_project: 'Редизайн сайта',
    preview_search: 'Поиск',
    preview_filters: 'Фильтры',
    preview_filter_mine: 'Мои задачи',
    preview_filter_tagged: 'С тегами',
    preview_filter_tracked: 'Отслежено сегодня',
    preview_todo: 'К выполнению',
    preview_doing: 'В работе',
    preview_done: 'Готово',
    preview_card_onboarding: 'Экраны онбординга',
    preview_card_ora: 'Ограничить спам ORA ORA ORA в комментариях',
    preview_card_invoices: 'Ежемесячные счета',
    preview_card_icons: 'Новый набор иконок',
    preview_card_clash_royale: 'Nerf Mega Knight',
    preview_tag_bug: 'Баг',
    preview_tag_design: 'Дизайн',
    preview_tag_release: 'Релиз',
  },
  profile: {
    password_title: 'Сделайте его трудным для подбора',
    password_hint: 'Требования подсвечиваются по мере ввода.',
    rule_length: '{count} или более символов',
    rule_number: 'Минимум одна цифра',
    rule_uppercase: 'Заглавная буква',
    rule_match: 'Пароли совпадают',
    rule_no_spaces: 'Без пробелов',
    rule_different: 'Отличается от текущего пароля',
    save_password: 'Сохранить пароль',
    username_required: 'Имя не может быть пустым',
    profile_saved: 'Профиль сохранён',
    username_invalid: "Имя может содержать только буквы, цифры, пробелы и . , - _ ' ’ & ( ) {'@'} +",
    profile_save_failed: "Не удалось сохранить профиль, попробуйте ещё раз",
    password_changed: 'Пароль изменён',
    delete_title: 'Удалить вашу учётную запись?',
    will_be_removed: 'Будет удалено',
    removed_profile: 'Профиль, фото и настройки',
    removed_access: 'Доступ ко всем рабочим пространствам и проектам',
    removed_settings: 'Выходные и личные настройки',
    type_delete_prefix: 'Введите',
    type_delete_suffix: 'для подтверждения',
    keep_account: 'Оставить аккаунт',
    delete_forever: 'Удалить навсегда',
    subtitle: 'Данные вашей учётной записи и настройки',
    section_photo: 'Фото профиля',
    section_personal: 'Личная информация',
    section_appearance: 'Внешний вид',
    section_security: 'Безопасность',
    section_danger: 'Опасная зона',
    upload_new: 'Загрузить новое',
    photo_hint: 'PNG или JPG, до 5 МБ',
    name_hint: 'Видно вашим коллегам в задачах и комментариях',
    theme_hint: 'Применяется ко всем вашим рабочим пространствам и устройствам Tracklify',
    change_password: 'Изменить пароль',
    delete_account_hint: 'Навсегда удаляет вашу учётную запись и все личные данные. Это нельзя отменить.',
    delete_account_button: 'Удалить аккаунт',
    Cancel: 'Отмена',
    old_password_placeholder: 'Введите текущий пароль',
    new_password_placeholder: 'Минимум {count} символов',
    repeat_password_placeholder: 'Повторите новый пароль',
    days_off_visibility_hint: 'Выберите, кто видит, когда вас нет на ваших проектах',
    days_off_everyone: 'Все',
    days_off_members_only: 'Только участники',
    unsaved_changes: 'Есть несохранённые изменения',
    Configure_user_profile: 'Настройки профиля',
    General: 'Общие',
    Privacy: 'Конфиденциальность',
    days_off_visibility_title: 'Кто может видеть мои выходные?',
    days_off_visible_to_everyone: 'Все участники моих проектов, включая гостей рабочего пространства',
    days_off_hidden_from_guests: 'Только участники и администраторы рабочего пространства в моих проектах',
    Name_Surname: 'Имя & Фамилия',
    Avatar: 'Аватар',
    Email: 'Е-мейл',
    CHANGE_PASSWORD: 'ИЗМЕНИТЬ ПАРОЛЬ',
    DELETE_ACCOUNT: 'УДАЛИТЬ АККАУНТ',
    Old_password: 'Старый пароль',
    New_password: 'Новый пароль',
    Repeat_new_password: 'Повторите новый пароль',
    CANCEL: 'Отменить',
    Fill_this_field: 'Заполните это поле',
    Old_password_is_incorrect: 'Старый пароль неверен',
    Password_must_be_same: 'Пароли должны быть одинаковыми',
    Change_user_password: 'Изменение пароля пользователя',
    Password_must_be_at_least: 'Пароль должен быть не менее',
    characters: 'символов',
    destroy_your_account: 'Это уничтожит запись вашей учетной записи пользователя',
    type_delete_to_confirm: 'Введите DELETE, если вы уверены',
    delete_me: 'УДАЛИТЬ МЕНЯ',
  },
  time: {
    M: 'М',
    S: 'С',
    d: 'д',
    w: 'н',
    y: 'г',
    H: 'Ч',
  },
  button: {
    Yes: 'Да',
  },
  recording: {
    Record_your_screen: 'Запишите свой экран',
    Record_Microphone: 'Запись микрофона',
    Record_Webcam: 'Запись Веб-камеры',
    cant_start_rec: 'Не удается начать запись экрана, вы выбрали экран? Ошибка',
    Cant_start_camera: 'Невозможно начать запись с камеры, вы дали разрешение? Ошибка',
    Webcamera_preview: 'Предварительный просмотр',
    Start_recording: 'Начать запись',
    recording_screen_now: 'Сейчас вы записываете свой экран',
    Stop_recording: 'Остановить запись',
  },
  loader: {
    Loading: 'Загрузка',
  },
  rule: {
    When: 'Когда',
    Else: 'Еще',
    Action: 'Действие',
    Condition: 'Состояние',
  },
  trackTimeBar: {
    Unassign: 'Не назн.',
  },
  downloadMobile: {
    Get_Tracklify_mobile: 'Скачайте мобильное приложение Tracklify',
    Browse: 'Просматривайте,',
    discuss_your_tasks: 'обсуждайте свои задачи, управляйте командой на мобильном телефоне или',
    quickly_creates_tasks: 'быстро создавайте задачи из общих скриншотов',
    You_have_Tracklify: 'У вас уже есть приложение Tracklify на вашем смартфоне',
    Reports: 'Отчеты',
  },
  title: {
    select_text_and: 'выберите текст и ctrl + l',
  },
  trackingNotice: {
    __tracking_going:
      'Tracklify будет делать скриншоты, чтобы подтвердить, что вы потратили время на работу',
    __please_share: 'Пожалуйста, поделитесь всем экраном',
    __choose_entire_screen: 'В окне браузера выберите «Весь экран», затем нажмите «Поделиться»',
    __window_or_tab_wont_work: 'Доступ к отдельному окну или вкладке Chrome не подойдёт',
    __tracking_makes_screenshots:
      'Tracklify делает только один снимок экрана в 10 минут с небольшым случайным сдвигом времени',
    __screenshots_securely:
      'Скриншоты надежно хранятся в облаке и всегда могут быть просмотрены и удалены',
    __press_cancel: 'Пожалуйста, нажмите Отменить, если вы не хотите подтверждать время',
    __good_try: 'Хорошая попытка!',
    __selected_one: 'Но вы выбрали',
    __selected_two: 'вместо всего экрана',
    __canceled_sharing: 'Вы отключили отслеживание',
    __unfortunately: 'К сожалению, мы не сможем отследить ваше время',
    __you_ws_admin: 'Потому что вы администратор рабочего пространства, вы можете:',
    __we_will_notify: 'Мы сообщим вам, когда скриншот будет сделан или отслеживание остановится',
    __please_notify: 'Пожалуйста разрешите уведомления',
    __notifications_only: 'Tracklify отправляет уведомления только при изменениях статуса трекинга',
    __we_recommended_notifications: 'Мы также рекомендуем убедиться, что уведомления вашего браузера включены в настройках операционной системы',
    __we_recommended_idle:
      'Рекомендуем разрешить доступ к ниформации о использовании устройства',
    __we_will_idle: 'Мы будем проверять ваше бездействие',
    __needs_device_use:
      'Tracklify использует разрешение "Использовать ваше утсройство" для автоматической остановки трекинга, когда вы не работаете дольше 10 минут.',
    __provide_better:
      'Эта настройка используется только для обеспечения надёжного трекинга, никакие данные о пользователе не собираются',
    __well_done: 'Отлично',
    __we_recommended_hide_popup: 'Рекомендуем спрятать всплываюещее окно что бы не мешало работе',
    __just_press: 'Просто нажмите скрыть',
    __to_leave:
      'Чтобы звершить работу и прекратить трекинг, пожалуйста, просто закройте вкладку браузера с Tracklify',
    __sorry_we_cant: 'Жаль, но мы не можем начать трекинг',
    __we_dont_have_perm: 'У нас нет разрешения на доступ вашей активности. Пожалуйста, сбросьте все разрешения что бы браузер запросил их вновь.',
    __try_again_btn: 'Попробовать снова',
    __dont_track: 'Хорошо, не отслеживать часы в этот раз',
    __enable_without: 'Включить отслеживание времени без скриншотов для проекта',
    __dont_show_again: 'Не показывать снова',
    __close: 'Закрыть',
    andReload: 'И затем обновите страницу',
    __choose_chrome_browser: 'Так как Треклифай использует современный IDLE detection API<br>он может полноценно работать только в браузере Chrome (или основанном на Chrome)',
    __otherwise: 'В противном случае вы можете скачать настолькое приложение:',
    __download: 'Скачать',
    __update_tracker: 'Обновить',
    __installing_update: 'Установка…',
    __update_failed: 'Не удалось обновить. Нажмите «Обновить», чтобы повторить попытку.',
    __you_can_disable_screenshots: 'Поскольку Вы являетесь создателем проекта, Вы можете отключить создание скриншотов в',
    __project_settings: 'настройках проекта',
  },
  combobox: {
    nothing_found: 'Ничего не найдено',
    create_hint: 'Нажмите Enter, чтобы добавить «{query}»',
    clear: 'Очистить',
  },
  taskFilters: {
    filter: 'Фильтр',
    title: 'Фильтры',
    applyFilters: 'Применить фильтры',
    show_more: 'Показать больше',
    hide: 'Скрыть',
    createdTime: 'Дата создания',
    today: 'Сегодня',
    yesterday: 'Вчера',
    assignee: 'Назначена на',
    executor: 'Исполнитель',
    createdBy: 'Создана кем',
    tags: 'Теги',
    withTags: 'С тегами',
    avgUserVelocityPerDay: 'Средн. время пользователя за день',
    userAlreadyTrackedTimeByTag: 'Затреканное время по тегу',
    estimation: 'Оценка',
    inTotal: 'Итого:',
  },
  projectPriorities: {
    title: 'Порядок проектов',
    hint: 'Перетаскивайте проекты, чтобы задать порядок их групп в «Моих задачах». Срочные задачи всегда сверху, низкоприоритетные — внизу.',
    empty: 'Ещё не участник ни одного проекта',
    archived: 'В архиве',
  },
  taskHistory: {
    empty: 'Здесь пока нет затреканных задач',
    empty_hint: 'Запустите таймер на задаче или измените период и фильтры.',
    search: 'Поиск',
    period: 'Период',
    projects: 'Проекты',
    stages: 'Стадии',
    search_placeholder: 'Поиск по названию или номеру',
    projects_placeholder: 'Все проекты',
    stages_placeholder: 'Все стадии',
    all: 'Все время',
    today: 'Сегодня',
    yesterday: 'Вчера',
    last_week: 'Прошлая неделя',
    last_month: 'Прошлый месяц',
    older: 'Ранее',
  },
  myTasks: {
    task_sorted_by_priority: 'Задачи за приоритетом',
    mentions: 'Упомянуто',
    recents: 'Недавние',
    liked: 'Избранное',
    total: 'суммарно',
    total_unreads: 'непрочитанных',
    total_updates: 'обновлений',
    no: 'нету',
    openProject: 'Открыть проект',
    open: 'Открыть',
  },
  addTask: {
    project: 'Проект',
    search_projects: 'Поиск проектов...',
    no_projects_found: 'Проекты не найдены',
    tags: 'Теги',
    no_tags: 'Нету тегов',
    search_tags: 'Поиск тегов...',
    nothing_found: 'Ничего не найдено',
    create_tag: 'создать «{name}»',
    create_tag_hint: 'или нажмите enter',
    no_tags_hint: 'В этом проекте ещё нет тегов.',
    create_task: 'Создать задачу',
    create_subtask_for: 'Создать подзадачу для {task}',
    placeholder: 'Введити текст задачаи здесь',
    select_picture: 'Выбрать изображение',
    ctrl_v_paste: 'Ctrl+V, чтобы вставить изображение из буфера обмена',
    tap_to_attach: 'Нажмите, чтобы прикрепить изображение',
    or: 'или',
    select_exactly_image: 'Пожалуйста, выберите изображение',
  },
  invoiceAutoGen: {
    button: 'Автогенерация',
    save_template_first: 'Сначала сохраните шаблон',
    title: 'Автогенерация инвойса',
    description: 'Генерируется 1-го числа каждого месяца за предыдущий месяц с текущими фильтрами отчёта.',
    active: 'Активна',
    off: 'Выключена',
    next_invoice_in: 'Следующий инвойс через {count} дн.',
    not_generated: 'Инвойсы не будут генерироваться',
    turn_off: 'Выключить',
    save_failed: 'Не удалось включить автогенерацию: проверьте адреса',
    invoice_for: '{date} · инвойс за {month}',
    sent_to: 'Получателей: {count}',
    will_be_sent_to: 'Будет отправлено получателям: {count}',
    email: 'Email',
    additional_email: 'Дополнительный email',
    additional_email_placeholder: "напр. accountant{'@'}company.com",
    initiated_by: 'Инициатор:',
  },
  devtools: {
    title: 'AI и автоматизация',
    subtitle: 'Работайте с Tracklify из терминала и из AI-ассистентов для кода.',
    copy: 'Копировать',
    regenerate: 'Обновить',
    cli: {
      terminal: 'tracklify — cli',
      title: 'Получить Tracklify CLI',
      subtitle: 'Получите приложение Tracklify CLI, чтобы автоматизировать операции вроде git.',
      token_hint: 'Ваш токен личный и секретный. Храните его в безопасности.',
      regenerate_title: 'Обновить токен CLI?',
      regenerate_subtitle: 'Всем авторизованным клиентам придётся войти заново.',
      regenerated: 'Токен CLI обновлён',
      regenerate_failed: 'Не удалось обновить токен CLI',
      branch_hint: 'Создать новую ветку для текущей задачи',
      branch_output: 'Создаст ветку вида feature/<projectname>/<taskHid>/<taskSlug>',
      commit_hint: 'Добавить ссылку на задачу в коммит',
      commit_output: 'Создаст коммит вида "my text <projectname>/<taskHid>/<taskSlug>"',
    },
    mcp: {
      terminal: 'tracklify — mcp',
      title: 'Получить Tracklify MCP',
      subtitle: 'Подключите MCP-клиент к своему рабочему пространству Tracklify.',
      token_hint: 'Добавьте этот заголовок со своим личным токеном. Он даёт доступ к Tracklify от вашего имени, поэтому храните его в секрете.',
      regenerate_title: 'Обновить токен MCP?',
      regenerate_subtitle: 'Клиенты с этим токеном потеряют доступ. Приложения, подключённые через OAuth, продолжат работать.',
      regenerated: 'Токен MCP обновлён',
      regenerate_failed: 'Не удалось обновить токен MCP',
      claude_code_step1: 'Выполните в терминале.',
      claude_code_step2: 'Затем выполните в Claude Code, выберите tracklify и нажмите Authenticate.',
      codex_step: 'Codex откроет Tracklify в браузере для входа; если нет — выполните codex mcp login tracklify.',
      antigravity_step: 'Добавьте в ~/.gemini/config/mcp_config.json. У Antigravity нет входа через OAuth для Tracklify, поэтому он использует ваш личный токен.',
      other_step: 'Добавьте этот URL в свой MCP-клиент. С входом через OAuth он откроет Tracklify в браузере, чтобы запросить ваше разрешение; иначе добавьте заголовок ниже.',
      key: 'Ключ',
      value: 'Значение',
    },
    connections: {
      title: 'Подключённые приложения',
      empty: 'Через вход OAuth пока не подключено ни одного приложения.',
      app: 'Приложение',
      connected: 'Подключено',
      last_active: 'Последняя активность',
      disconnect: 'Отключить',
      disconnect_failed: 'Не удалось отключить приложение',
    },
  },
  profitShare: {
    breadcrumb: 'Profit-share проект /',
    search_projects: 'Поиск Profit-share проектов',
    author: 'Автор',
    no_accessible_projects: 'Нет доступных проектов',
    confidential_badge: 'Конфиденциально · скриншоты размыты',
    projects_stack: 'проекты',
    members_stack: 'участники',
    no_participating_projects: 'Нет проектов-участников',
    only_author_access: 'Сейчас доступ есть только у автора.',
    edit_project: 'Редактировать проект',
    create_project: 'Создать Profit-share проект',
    return_to_admin: 'Вернуться в режим админа',
    view_as_non_admin: 'Смотреть как не-админ',
    loading_project: 'Загрузка Profit-share проекта…',
    sections_aria: 'Разделы Profit-share',
    tab_overview: 'Обзор и доход',
    tab_rates: 'Ставки участников',
    tab_audit: 'Журнал аудита',
    choose_title: 'Выберите Profit-share проект',
    access_count: 'Доступных проектов: {n}.',
    opening_shows: 'Открытый проект показывает конфиденциальные данные о зарплатах.',
    tracklify_projects_count: 'Проектов Tracklify: {n}',
    members_count: 'Участников: {n}',
    new_project: 'Новый проект',
    landing_kicker: 'Profit-share',
    landing_title: 'Прозрачно распределяйте прибыль между своими проектами',
    landing_text: 'Profit-share проект объединяет доход и отслеженные затраты нескольких проектов Tracklify, а остаток распределяет между участниками.',
    no_access_yet: 'У вас пока нет доступа к Profit-share проекту.',

    all_participating: 'Все проекты-участники',
    overview_reveal_hint: 'Ставки и затраты участников остаются конфиденциальными, пока ячейка участника за месяц не раскрыта.',
    export_csv: 'Экспорт CSV без участников',
    no_operations: 'Отслеженных операций пока нет.',
    rate_missing: 'Нет ставки',
    vs_six_months: '{change} по сравнению с 6 мес. назад',
    carry_over: '(перенесено {amount})',
    reveal_rate: 'Раскрыть ставку',
    reveal_rate_aria: 'Раскрыть ставку {member} за {month}',
    rate_line: 'ставка {rate}',
    mentor_line: '+ ментор {rate}',
    no_effective_rate: 'Нет действующей ставки',
    projects_loaded: 'Загружено проектов: {n}',
    load_details: 'Проект «{name}» загружен за {seconds} с · запрос агрегации {query} с',
    loading_operations: 'Загрузка операций проектов…',
    no_participating_selected: 'Проекты-участники не выбраны.',
    add_revenue: 'Добавить доход',
    revenue: 'Доход',
    latest: 'Последний',
    no_description: 'Без описания',
    rate_not_set: 'Ставка не задана',
    delete_revenue_confirm: 'Удалить этот доход?',
    delete_revenue: 'Удалить доход',
    no_revenue: 'Дохода пока нет',
    no_revenue_hint: 'Прибыль остаётся отрицательной, пока не добавлен доход.',
    update_revenue: 'Обновить доход',
    revenue_invalid: 'Сумма и ставка должны быть положительными числами, например 1200.50',
    col_month: 'Месяц',
    col_total_spend: 'Общие затраты',
    col_rate_efficiency: 'Эффективность ставки',
    col_monthly_profit: 'Прибыль за месяц',
    col_distributable_profit: 'Прибыль к распределению',
    col_accumulated_profit: 'Накопленная прибыль',

    tracklify_project: 'Проект Tracklify',
    rate_per_hour: 'Ставка ({currency}/ч)',
    amount: 'Сумма',
    currency: 'Валюта',
    date: 'Дата',
    sold_hours: 'Проданные часы',
    note: 'Примечание',
    note_placeholder: 'напр. счёт за сентябрь',

    member_rates_title: 'Зарплатные ставки участников',
    rates_hint: 'Одно обновление на участника в месяц. Ставка действует, пока её не заменит более новое обновление.',
    rates_reveal_hint: 'Ставки остаются конфиденциальными, пока ячейка участника за месяц не раскрыта.',
    add_rate_update: 'Добавить обновление ставки',
    no_rates_warning: 'Ставок пока нет. Затраты и прибыль нельзя посчитать, пока у участников, которые трекают время, нет ставки.',
    select_projects_first: 'Прежде чем добавлять ставки, выберите проекты-участники с подтверждёнными участниками.',
    no_rate_history: 'Истории ставок пока нет.',
    confidential_rate: 'Конфиденциальная ставка',
    edit_rate: 'Редактировать ставку',
    mentor_rate_line: 'Ментор: {rate}',
    hours_not_estimated: 'Часы не оценены',
    add_monthly_rate: 'Добавить месячное обновление ставки',
    add_rate: 'Добавить ставку',
    rates_invalid: 'Ставки должны быть числами, например 25.50',
    member: 'Участник',
    search_members: 'Поиск участников',
    no_members_found: 'Участники не найдены',
    month: 'Месяц',
    new_rate: 'Новая ставка',
    mentor_rate: 'Ставка ментора',
    note_optional: 'Примечание (необязательно)',

    new_ps_project: 'Новый Profit-share проект',
    edit_ps_project: 'Редактировать Profit-share проект',
    project_name: 'Название проекта',
    project_name_placeholder: 'напр. Agency pool 2026',
    members_access: 'Участники с конфиденциальным доступом',
    add_members: 'Добавьте участников воркспейса…',
    members_access_hint: 'Они будут видеть зарплатные ставки, затраты, доход и прибыль.',
    access_list_author_only: 'Список конфиденциального доступа видит только автор проекта.',
    participating_projects: 'Участвующие проекты Tracklify',
    add_projects: 'Добавьте проекты…',
    participating_hint: 'Этим списком управляют админы воркспейса. Ставки общие для всех выбранных проектов.',
    create_project_btn: 'Создать проект',
    save_project: 'Сохранить проект',

    reveal_title: 'Раскрыть конфиденциальную ставку?',
    warning: 'Предупреждение',
    reveal_admin_text: 'Вы раскрываете эту ставку как администратор, поэтому эта попытка не попадёт в журнал аудита. Те же обязательства по конфиденциальности всё равно действуют.',
    reveal_member_text: 'Если продолжите, эта попытка раскрытия будет навсегда записана в журнал аудита от вашего имени. {member} сможет бессрочно получать информацию об этой попытке. Запись в журнале нельзя удалить, а это действие нельзя отменить.',
    confidential_caps: 'КОНФИДЕНЦИАЛЬНО',
    confidential_text: 'Информация о ставках строго конфиденциальна и может быть защищена соглашением с участником. Раскрывая её, вы берёте на себя полную ответственность за сохранность этой информации.',
    revealing: 'Раскрытие…',
    reveal: 'Раскрыть',

    confidential: 'Конфиденциально',
    consent_title: 'Чувствительная информация Profit-share',
    rule_see_title: 'Что вы увидите',
    rule_see_text: 'Этот Profit-share проект показывает конфиденциальные зарплатные ставки, отслеженные затраты, доход и прибыль.',
    rule_stop_title: 'Дальше вас это не уйдёт',
    rule_stop_text: 'Каждый сотрудник компании имеет право сохранять в тайне свою ставку, её историю и причины её изменения. Хотя прозрачность модели Profit-share делает раскрытие авторизованным участникам неизбежным, любое дальнейшее распространение должно остановиться на том, кто это просматривает.',
    rule_share_title: 'Не распространяйте и не фиксируйте',
    rule_share_text: 'Нельзя распространять или фиксировать эту информацию в публичных источниках, скриншотах, записях экрана, сообщениях или любой другой форме. Передача этой информации кому-либо без доступа может привести к вашему исключению из Profit-share. Tracklify автоматически размывает скриншоты, сделанные, пока Profit-share открыт.',
    consent_agree: 'Я понимаю все правила и согласен, что меня могут исключить из Profit-share, если я каким-либо образом распространю или зафиксирую конфиденциальную информацию.',
    asked_again: 'На новом устройстве или в другом браузере вас спросят снова.',
    agree_open: 'Согласиться и открыть',

    audit_title: 'Журнал аудита',
    audit_hint_full: 'Изменения дохода, изменения зарплатных ставок и раскрытия конфиденциальных ставок.',
    audit_hint_limited: 'Действия с доходом и ваши собственные раскрытия конфиденциальных ставок.',
    loading_audit: 'Загрузка журнала аудита…',
    no_audit: 'Записей аудита пока нет.',
    page_info: 'Страница {page} из {pages} · записей: {total}',
    col_time: 'Время',
    col_user: 'Пользователь',
    col_entity: 'Объект',
    col_action: 'Действие',
    col_diff: 'Изменения',
    filter_all_full: 'Вся финансовая активность',
    filter_all_limited: 'Доход и мои действия',
    filter_salary: 'Зарплатные ставки',
    filter_reveals: 'Раскрытия ставок',
    filter_my_reveals: 'Мои раскрытия ставок',
    entity_salary: 'Зарплатная ставка',
    entity_reveal: 'Раскрытие ставки',
  },
  invoices: {
    invoice_basis: 'Основа счёта',
    close_invoice_basis: 'Закрыть основу счёта',
    close: 'Закрыть',
    edit_filters: 'Изменить фильтры',
    projects: 'Проекты',
    include_tags: 'Включить теги',
    exclude_tags: 'Исключить теги',
    executors: 'Исполнители',
    count_projects: 'Проектов: {n}',
    count_incl_tags: 'Включ. тегов: {n}',
    count_excl_tags: 'Исключ. тегов: {n}',
    count_executors: 'Исполнителей: {n}',
    block_formatting: 'Форматирование блока',
    font_size_value: 'Размер шрифта: {size}',
    font_size: 'Размер шрифта',
    alignment: 'Выравнивание',
    column_width: 'Ширина столбцов',
    delete_block: 'Удалить блок',
    delete_text_cell: 'Удалить эту текстовую ячейку',
    add_row_after: 'Добавить строку ниже',
    add_row_after_title: 'Добавить новую строку после этой',
    delete_column: 'Удалить столбец',
    delete_column_title: 'Удалить этот столбец из таблицы',
    confirm_delete: 'Подтвердить удаление?',
    confirm_deletion: 'Подтвердить удаление',
    cancel_deletion: 'Отменить удаление',
    yes: 'Да',
    no: 'Нет',
    font_large: 'Крупный шрифт (16px)',
    font_medium: 'Средний шрифт (14px)',
    font_small: 'Мелкий шрифт (12px)',
    font_extra_small: 'Очень мелкий шрифт (10px)',
    align_left: 'По левому краю',
    align_center: 'По центру',
    align_right: 'По правому краю',
    equal_width_columns: 'Столбцы одинаковой ширины',
    dynamic_width_columns: 'Столбцы динамической ширины',
    invoice_generator: 'Генератор счетов',
    invoice_layout: 'Макет счёта',
    add_section: 'Добавить раздел',
    add_text_section: 'Добавить текстовый раздел',
    add_table_section: 'Добавить таблицу',
    add_block_right: 'Добавить блок справа',
    add_column_right: 'Добавить столбец справа',
    empty_block: 'Пустой блок',
    new_row_col: 'Новая строка {row}, столбец {col}',
    new_column: 'Новый столбец {n}',
    delete_table: 'Удалить таблицу',
    delete_row: 'Удалить строку',
    delete_table_title: 'Удалить всю таблицу',
    delete_row_title: 'Удалить эту строку из таблицы',
    invoice_preview: 'Предпросмотр счёта',
    download: 'Скачать',
    generating_pdf: 'Создаём PDF…',
    opening_pdf_preview: 'Открываем предпросмотр PDF…',
    page_of: 'Страница {current} из {total}',
    pdf_generation_failed: 'Не удалось создать PDF',
    pdf_generation_error: 'При создании предпросмотра PDF произошла ошибка. Попробуйте ещё раз.',
    retry: 'Повторить',
    saving: 'Сохраняем…',
    saved: 'Сохранено',
    choose_template: 'Выберите шаблон счёта',
    choose_template_description: 'Выберите сохранённый шаблон, чтобы создать счёт для отфильтрованных задач, или начните новый с нуля.',
    your_templates: 'Ваши шаблоны',
    legacy_badge: 'LEGACY',
    shared_badge: 'ОБЩИЙ',
    created_date: 'Создан {date}',
    created_colon_date: 'Создан: {date}',
    last_pdf: 'Последний PDF: {date}',
    never_capital: 'Никогда',
    never: 'никогда',
    or: 'или',
    create_new_template: 'Создать новый шаблон',
    template_name: 'Название шаблона',
    save_name: 'Сохранить название',
    cancel_renaming: 'Отменить переименование',
    name_cant_be_empty: 'Название не может быть пустым',
    rename_hint: 'Enter — сохранить · Esc — отменить',
    duplicate_name: 'Дублировать {name}',
    duplicate: 'Дублировать',
    rename_name: 'Переименовать {name}',
    rename: 'Переименовать',
    delete_name: 'Удалить {name}',
    delete: 'Удалить',
    templates: 'Шаблоны',
    find_template_placeholder: 'Найти шаблон…',
    find_template: 'Найти шаблон',
    no_templates_match: 'Нет шаблонов по запросу «{query}»',
    new_template: 'Новый шаблон',
    pinned: 'Закреплено',
    pinned_title: 'Системная закреплённая переменная, существует всегда',
    auto: 'Авто',
    about_name: 'О {name}',
    edit_name_description: 'Изменить описание {name}',
    edit_description: 'Изменить описание',
    unlock_name_value: 'Разблокировать значение {name}',
    lock_name_value: 'Заблокировать значение {name}',
    unlock_variable: 'Разблокировать переменную',
    lock_variable: 'Заблокировать переменную',
    enter_variable_description: 'Введите описание переменной',
    available_variables: 'Доступные переменные',
    current_value: 'Текущее значение',
    no_variables_found: 'Не найдено переменных, похожих на «{query}»',
    error_badge: 'ОШИБКА',
    template_and_basis: 'Шаблон и основа счёта',
    reset: 'Сбросить',
    unshare_template: 'Закрыть общий доступ к шаблону',
    shared_click_to_unshare: 'Шаблон доступен воркспейсу. Нажмите, чтобы закрыть доступ',
    save_and_share_confirm: 'Сохранить шаблон и поделиться им с воркспейсом? Участники воркспейса увидят ваш шаблон и переменные (только просмотр).',
    share_confirm: 'Поделиться шаблоном с воркспейсом? Участники воркспейса увидят ваш шаблон и переменные (только просмотр).',
    share_template: 'Поделиться шаблоном с воркспейсом',
    share: 'Поделиться',
    legacy_template_notice: 'Это устаревший шаблон. Его нельзя редактировать здесь, но можно скачать его HTML.',
    download_legacy_html: 'Скачать устаревший HTML',
    template_variables: 'Переменные шаблона',
    template_owner: 'Владелец шаблона',
    unknown_user: 'Неизвестный пользователь',
    current_marker: '(Текущий)',
    save_and_generate: 'Сохранить и создать',
    generate: 'Создать',
    delete_template_confirm: 'Вы уверены, что хотите удалить этот шаблон?',
    unsaved_leave_message: 'Сохранить изменения в этом шаблоне, прежде чем выйти из него?',
    keep_editing: 'Продолжить редактирование',
    untitled_template: 'Шаблон без названия',
    template_copy_name: '{name} (копия)',
  },
  salary: {
    salary_projects_breadcrumb: 'Зарплатные проекты /',
    select_salary_project: 'Выберите зарплатный проект',
    generates_monthly_on_day: 'Генерируется ежемесячно, день {day}',
    generates_weekly_on_day: 'Генерируется еженедельно, день {day}',
    recalculating_results: 'пересчитываем результаты..',
    create_salary_project: 'Создать зарплатный проект',
    edit_salary_project: 'Редактировать зарплатный проект',
    confirm_delete_project: 'Вы уверены, что хотите удалить этот зарплатный проект?',
    delete: 'Удалить',
    no_projects_yet: 'Зарплатных проектов пока нет. Создайте первый, чтобы начать.',
    current_period_not_settled: 'Текущий · {progress} · не закрыт',
    day_progress: 'день {day} из {total}',
    members_count: 'Участников: {n}',
    across_members: 'среди участников: {n}',
    add_member: 'Добавить участника',
    search_members: 'Поиск участников',
    add_member_to_current_period: 'Добавить участника в текущий период',
    member: 'Участник',
    user_vars: 'Переменные пользователя',
    calculated: 'Рассчитано',
    export_column_csv: 'Экспортировать эту колонку в CSV',
    confirm_remove_member: 'Удалить этого участника из текущего периода?',
    remove_member: 'Удалить участника',
    summary: 'Итог',
    columns_count: 'Колонок: {shown} из {total}',
    metric_min: 'мин',
    metric_avg: 'сред',
    metric_max: 'макс',
    metric_median: 'медиана',
    metric_sum: 'сумма',
    show_min: 'Показать мин',
    show_avg: 'Показать сред',
    show_max: 'Показать макс',
    show_median: 'Показать медиану',
    show_sum: 'Показать сумму',
    select_project_from_list: 'Выберите зарплатный проект из списка выше.',
    popup_subtitle: 'Зарплаты генерируются автоматически по расписанию.',
    project_name: 'Название проекта',
    project_name_placeholder: 'напр. Киевская команда',
    frequency: 'Частота',
    week: 'Неделя',
    month: 'Месяц',
    day_of_month: 'День месяца',
    day_of_week: 'День недели',
    of_max_day: 'из {max}',
    timezone: 'Часовой пояс',
    select_timezone: 'Выберите часовой пояс',
    recreate_to_change_settings: '(чтобы изменить настройки выше, создайте проект заново)',
    variables: 'Переменные',
    add_variable: 'Добавить переменную',
    no_variables_yet: 'Переменных пока нет. Добавьте значения для каждого участника, например базовую зарплату или почасовую ставку.',
    move_up: 'Переместить вверх',
    move_down: 'Переместить вниз',
    create_project: 'Создать проект',
    average_salary: 'Средняя зарплата',
    total_hours: 'Всего часов',
    predicted_salary: 'Прогнозируемая зарплата',
    actually_earned: 'Фактически заработано',
    own_hours: 'Собственные часы',
    end_of_month_forecast: 'прогноз на конец месяца',
    base_percent_hint: 'база {base} · {percent}% от базы',
    incl_base_in_eur: 'с учётом базы · в EUR',
    at_rate_per_hour: 'по ставке {rate}/ч',
    not_receiving_salary_yet: 'вы пока не получаете зарплату в этом проекте',
    var_desc_user_time_spent: 'Время пользователя (часы) за период; необязательно: 3-й аргумент = email, 4-й аргумент = название проекта',
    var_desc_user_prediction_median: 'Медиана USER_TIME_SPENT за предыдущие N периодов (часы); необязательные фильтры email/проект',
    var_desc_min: 'Возвращает минимальное из двух числовых аргументов',
    var_desc_previous_salary_point: 'Баланс предыдущей зарплатной записи',
    var_desc_user_vars: 'Пользовательская переменная (замените var_name на свой ключ)',
    var_desc_exchange_rate: 'Курс обмена {alias}',
    var_desc_exchange_rate_month_start: 'Курс НБУ на 1-й день месяца периода (USD-UAH, EUR-UAH, PLN-UAH, CAD-UAH)',
    var_desc_previously_defined: 'Ранее определённая переменная',
    csv_copied: 'CSV скопирован в буфер обмена',
    csv_copy_failed: 'Не удалось скопировать CSV. Попробуйте ещё раз.',
  },
  tags: {
    burned_hours: 'Потраченные часы',
    planned: 'Запланировано',
    passed: 'Выполнено',
    est_h: 'Оценка, ч',
    tracked: 'Затрекано',
    burned: 'Потрачено',
    avg_velocity: 'Ср. скорость',
    before_sprint: 'До спринта',
    during_sprint: 'Во время спринта',
    all_projects: 'Все проекты',
    all_sprint_tasks: 'Все задачи спринта',
    non_own_sprint_tasks: 'Чужие задачи спринта',
    non_this_project: 'Другие проекты',
    effort_change: 'Изменение усилий',
    native_level: 'Уровень в проекте',
    altruist: 'Альтруизм',
    sprint_start: 'Начало спринта',
    weekends_per_week: 'Выходных / неделя',
    days_in_sprint: 'Дней в спринте',
    show_velocity_stats: 'Показать статистику скорости',
    show_main_stats: 'Показать основную статистику',
    burndown: 'Burndown',
    remaining_vs_ideal_pace: 'Остаток часов по сравнению с идеальным темпом',
    remaining: 'Остаток',
    ideal: 'Идеал',
    remaining_hours: 'Остаток часов',
    ideal_burndown: 'Идеальный burndown',
    tag_focus_hotkey: 'Фокус на теге (Alt+G)',
    tag_focus: 'Фокус на теге',
    unfocus: 'Снять фокус',
    filter_tags: 'Фильтровать теги...',
    show_eta: 'Показать ETA',
    calculate_eta: 'Рассчитать ETA',
    export_settings: 'Настройки экспорта',
    include_executor: 'Добавить исполнителя',
    hours_in_story_point: 'Часов в story point',
    round_up_to: 'Округлять до',
    include_doing_hint: 'Добавлять ли колонку «doing», чтобы клиент мог включать/выключать пункты чекбоксом',
    include_doing: 'Добавить колонку Doing',
    notdoing_tag: 'Тег «Notdoing»',
    select_label: 'Выберите тег',
  },
  pages: {
    access_denied_title: 'Нам жаль',
    access_denied_subtitle: 'Что-то пошло не так, и вы вышли из активного рабочего пространства.',
    access_denied_select_workspace: 'Выберите рабочее пространство, чтобы продолжить',
    access_denied_no_workspaces: 'У вас пока нет доступных рабочих пространств.',
    access_denied_create_new: 'Создать новое',
    access_denied_logged_in_as: 'Вы вошли как {email}',
    access_denied_login_another: 'Войти в другой аккаунт',
    ai_automation_other_client: 'Другое',
    app_download_not_uploaded: 'Не загружено',
    mcp_authorize_title: 'Подключить {client}?',
    mcp_authorize_acts_on_behalf: '{client} ({host}) просит разрешения действовать от вашего имени в рабочем пространстве {workspace}: он будет видеть и изменять всё, что можете вы.',
    mcp_authorize_loopback_warning: 'После ответа браузер вернёт вас в приложение, запущенное на этом компьютере. Разрешайте, только если вы только что сами начали подключать {client}.',
    mcp_authorize_redirect_notice: 'После ответа браузер вернёт вас на {host}.',
    mcp_authorize_deny: 'Отклонить',
    mcp_authorize_allow: 'Разрешить',
    mcp_authorize_invalid: 'Этот запрос на авторизацию недействителен или истёк. Начните подключение заново из вашего MCP-клиента.',
    project_no_projects_title: 'У вас пока нет проектов 👀',
    project_no_projects_hint: 'Пожалуйста, {create_project} в меню слева вверху, нажав {no_projects}',
    project_create_project: 'создайте проект',
    project_no_projects: 'Нет проектов',
    project_settings_loading: 'Загрузка...',
    integrations_add: 'Добавить интеграцию',
    integrations_added_by: 'Добавил {name} · {date}',
    integrations_unknown_user: 'Неизвестно',
    integrations_close_config: 'Закрыть настройки',
    integrations_config: 'Настройки',
    integrations_delete_confirm: 'Удалить эту интеграцию?',
    integrations_default_description: 'Интеграция {name}',
    downtime_snooze_title: 'Отложить на 10 минут',
    task_notify_priority_title: 'Приоритет: {priority}',
    report_export_preparing: 'Подготовка…',
  },
  ui: {
    ai_chat_empty: 'Попросите меня показать ваши проекты или создать задачи.',
    ai_chat_error: 'Ошибка: {error}',
    ai_chat_openai_auth_error: 'AI-ассистент недоступен: ключ OpenAI API недействителен или истёк.',
    ai_chat_something_went_wrong: 'Что-то пошло не так',
    checklist_progress_title: 'Прогресс чек-листа: выполнено {done} из {total}',
    close_button_title: 'Закрыть [ESC]',
    comment_integration: 'Интеграция',
    comment_unknown_user: 'Неизвестный',
    common_header_create_task_title: 'Создать задачу [Alt+N]',
    create_task_error_reading_file: 'Ошибка чтения файла. Попробуйте ещё раз.',
    download_mobile_back: 'Назад',
    download_mobile_install_app: 'Установить приложение',
    editor_sign_up_not_confirmed: 'Регистрация не подтверждена',
    header_hidden_members: 'Ещё участников в проекте: {count}',
    hidden_screenshot_tooltip_in_project: 'Вы не можете просмотреть этот скриншот, так как не являетесь участником проекта {projectName}',
    hidden_screenshot_tooltip_no_project: 'Вы не можете просмотреть этот скриншот, так как не являетесь участником этого проекта',
    hidden_task_tooltip_in_project: 'Вы не можете просмотреть эту задачу, так как не являетесь участником проекта {projectName}',
    hidden_task_tooltip_no_project: 'Вы не можете просмотреть эту задачу, так как не являетесь участником этого проекта',
    integration_bot_name: 'Имя',
    integration_bot_title: 'Бот',
    integration_param_readonly: 'только чтение',
    pager_try_again_later: 'Попробуйте позже',
    recording_controls_microphone_level: 'Уровень микрофона',
    recording_controls_pause_title: 'Приостановить запись экрана',
    recording_controls_resume_title: 'Продолжить запись экрана',
    recording_controls_stop_title: 'Остановить запись экрана',
    searcher_no_tags: 'без тегов',
    searcher_with_tag: 'С тегом:',
    spinner_loading: 'Загрузка...',
    stage_enter_new_name: 'Название стадии не может быть пустым',
    stage_no_name: 'Стадия без названия',
    task_click_to_assign: 'Нажмите, чтобы назначить',
    task_dialog_comments_only: 'Только комментарии',
    task_dialog_drop: 'Перетащите сюда',
    task_dialog_logs_shown: 'Логи показаны',
    task_dialog_parent_task: 'Родительская задача',
    task_dialog_return_to_parent: 'Вернуться к родительской задаче',
    task_dialog_scroll_to_top: 'Прокрутить вверх',
    task_dialog_subtasks: 'Подзадачи',
    task_dialog_subtasks_caption: 'ПОДЗАДАЧИ',
    task_dialog_toggle_rightbar: 'Детали задачи',
    task_right_bar_add_subtask_title: 'Добавить подзадачу [Alt+Ctrl+N]',
    user_avatar_executor_title: '{username} — исполнитель этой задачи',
  },
};
